const locale = {
    lang: {
        by_contact: "By Contact",
        by_session: "By Chat",
        by_org: "Organizational",
        by_batch_import: "Import",
        useradd_type_partner: "My Partner",
        useradd_type_group: "My Group",
        useradd_type_org: "My Organization",
        useradd_type_session: "Recent Chats",
        common_tal: "好未来教育科技集团",
        useradd_all_org: "select by organization structure",
        useradd_all_contacts: "Frequent",
        useradd_recent_connect: "Recent Contacts",
        common_persion: "user",
        common_select_overrun: "number of selected users exceed the limit",
        useradd_all_select: "Select all",
        useradd_all_child: "subordinate",
        useradd_select_noresult: "No matching data",
        common_ok: "Confirm",
        useradd_select_search: "search",
        useradd_type_contact: "External",
        selected: "Selected: ",
        recent_forward_title: "Recent Forwards",

        partner_view: "View",

        sessionPickerTitleDefault: "Select chat",
        groupPickerTitleDefault: "My Group",
        userPickerTitleDefault: "Select user",
        orgPickerTitleDefault: "Select department",

        searchPlaceholderDefault: "Select",

        batch_import: "Batch Import",
        batch_import_tips: "Please enter the work ID",
        batch_import_tips1:
            "One per line, separated by carriage return and newline",
        batch_import_placeholder: "Please enter work ID",
        batch_import_input_limit_exceed:
            "The maximum limit has been exceeded, no further input is allowed",
        batch_import_paste_limit_exceed:
            "Exceeding the maximum limit, there are [xxx] work ID that failed to paste",
        batch_import_error:
            "[xxx] work IDs verification failed, please check and try again",
        batch_import_confirm: "Confirm import",
        batch_import_workcode_format_error:
            "Please enter the correct work ID format",
        batch_importing: "Importing...",

        batch_view_more_contacts: "More Contacts",
        batch_view_more_groups: "More Groups",
        batch_contacts: "Contacts",
        batch_groups: "Groups",

        common_manager1: "owner",
        common_manager2: "admin",

        cancel: "Cancel",

        search_tab_title_user: "Contacts",
        search_tab_title_group: "Group Chat",
        search_tab_title_org: "Department",
        search_loading_text: "loading",
        search_tips_text: "Please enter the search keyword",
        search_no_result_text:
            'No search No results matching "[xxx]" were found',

        load_more_text: "Loading more",
        selected_count_org_text: " Dept",
        selected_count_group_text: " group",
        selected_count_people_text: " people",
    },
};

export default locale;
